import Head from 'next/head'
import { useRouter } from 'next/router'
import { he } from '../../locales/he'
import { IPage, IRobots, isArticlePage } from '../../types'
import { mediaCdn } from '../Player/Helpers'
import { IdxMetaTags } from '../../sharedComponents'

type Props = {
  page: IPage
}

const Robots = ({ index, follow }: IRobots) => {
  return <meta name='robots' content={[index, follow].join(', ')} />
}
export const HeadTags = ({ page }: Props) => {
  const router = useRouter()

  const { robots, og } = page.SEO

  const image =
    og.image || `${mediaCdn}t_og_image/v1750236296/assets/2025/default.webp`

  const canRecommend =
    isArticlePage(page) && !page.Content.Item?.video?.name.includes('episode')
      ? 'true'
      : 'false'

  const path = router.asPath.split('?')[0]
  const isPaginated = path.includes('/page/')
  const canonical = isPaginated
    ? `https://13tv.co.il${path}`
    : page?.SEO?.canonical || `https://13tv.co.il${path}`

  return (
    <>
      <Head>
        <title>{page.SEO.title}</title>
        <meta
          name='viewport'
          content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
        />
        <meta name='description' content={page.SEO.description || he.logoAlt} />
        <meta name='keywords' content={page.SEO.keywords || ''} />
        <Robots {...robots} />
        <meta key={'og-title'} property='og:title' content={og.title} />
        <meta
          key={'og-description'}
          property='og:description'
          content={og.description}
        />
        <meta key={'og-image'} property='og:image' content={image} />
        <meta key={'og-url'} property='og:url' content={og.url} />
        {og.image_width && og.image_height && (
          <>
            <meta property='og:image:width' content={og.image_width} />
            <meta property='og:image:height' content={og.image_height} />
          </>
        )}
        <meta property='og:type' content={og.type} />
        <meta property='og:site_name' content={og.site_name} />
        <meta property='og:locale' content={og.local} />
        <meta name='canRecommend' content={canRecommend} />
        <meta name='publishDate' content={page.PageMeta.publishDate} />
        <meta
          name='minutely_reels'
          content={page.Content.Item?.promoteOnMinuteLy ? 'true' : 'false'}
        />
        {page.Content.Item?.gridTitle && (
          <meta name={'grid_title'} content={page.Content.Item?.gridTitle} />
        )}
        <link rel='canonical' href={canonical} />
      </Head>
      <IdxMetaTags
        title={page.SEO.title}
        path={router.asPath}
        author={page.Content.Item?.writers}
        description={og.description}
        categoryLevels={page.PageMeta.levels}
        tags={page.Content.Item?.tags}
      />
    </>
  )
}
